












































































import mixins from 'vue-typed-mixins'
import { Button, Input, Row, Col } from 'element-ui'
import Modal from '@/components/Modal'
import SubscribeGlobalAccelerator from '@/mixins/SubscribeGlobalAccelerator'
import './GlobalAcceleratorOverview.scss'

export default mixins(SubscribeGlobalAccelerator).extend({
  name: 'GlobalAcceleratorOverview',
  data: () => ({
    showPopup: false,
    gaUrl: '',
    wrtcUrl: ''
  }),
  methods: {
    addMapping () {
      this.$store.direct.dispatch.opsmonitor.addGlobalAcceleratorMapping({ gaUrl: this.gaUrl, wrtcUrl: this.wrtcUrl })
      this.gaUrl = ''
      this.wrtcUrl = ''
      this.showPopup = false
      this.$message(`Mapping from ${this.gaUrl} to ${this.wrtcUrl} has been made`)
    },
    remove (gaUrl: string) {
      this.$confirm('Are you sure you want to delete this mapping', 'Remove mapping').then(() => {
        this.$store.direct.dispatch.opsmonitor.removeGlobalAcceleratorMapping(gaUrl).then(() => {
          this.$message(`Mapping for ${gaUrl} has been removed`)
        }).catch(error => {
          this.$message('Could not remove global accelerator mapping ' + error.message)
        })
      }).catch(_error => {})
    }
  },
  components: {
    'el-button': Button,
    'el-input': Input,
    'el-row': Row,
    'el-col': Col,
    Modal
  }
})
